import { TranslocoPipe } from '@jsverse/transloco';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MatchScoringSurfaceComponent,
  MatchScoringSurfaceModel,
} from '../../matches/components/match-scoring-surface.component';

const LANDING_SCORING_PREVIEW: MatchScoringSurfaceModel = {
  teamA: {
    name: 'Team A',
    activePlayerName: 'Ines / Fabio',
    score: 14,
  },
  teamB: {
    name: 'Team B',
    activePlayerName: 'Johanna / Pia',
    score: 13,
  },
  servingTeamId: 'A',
  currentFaultCount: 1,
  currentSetNumber: 2,
  pointsTo: 15,
  hardCap: 17,
};

@Component({
  selector: 'app-landing-live-board',
  standalone: true,
  imports: [TranslocoPipe, MatchScoringSurfaceComponent],
  template: `
    <aside class="live-board" [attr.aria-label]="'landing.liveMatchScoringPreview' | transloco">
      <header class="board-topbar">
        <div class="board-topbar__lead">
          <strong>{{ 'landing.liveMatch' | transloco }}</strong>
        </div>
        <span class="board-clock"><i class="pi pi-clock" aria-hidden="true"></i>23:41</span>
      </header>

      <app-match-scoring-surface
        [model]="preview"
        [enabledControls]="noControls"
        [readOnly]="true"
        [ariaLabel]="'landing.readOnlyExampleOfLiveMatchScoringControls' | transloco"
      />

      <footer class="set-chips" aria-hidden="true">
        <span class="set-chip done"><span class="set-chip__num">{{ 'landing.set1' | transloco }}</span><span class="set-chip__score">15–12</span></span>
        <span class="set-chip active"><span class="set-chip__num">{{ 'landing.set2' | transloco }}</span><span class="set-chip__score">14–13</span></span>
        <span class="set-chip"><span class="set-chip__num">{{ 'landing.set3' | transloco }}</span><span class="set-chip__score">—</span></span>
      </footer>
    </aside>
  `,
  styles: [`
    .live-board {
      background: var(--color-surface);
      border: 1px solid var(--color-border-subtle);
      border-radius: var(--radius-card);
      box-shadow: var(--shadow-overlay);
      display: grid;
      gap: var(--space-4);
      padding: var(--space-5);
      width: 100%;
    }
    .board-topbar {
      align-items: center;
      display: flex;
      gap: var(--space-3);
      justify-content: space-between;
    }
    .board-topbar__lead {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-3);
      min-width: 0;
    }
    .board-topbar strong {
      font-size: var(--font-size-title);
      font-weight: 900;
    }
    .board-clock {
      align-items: center;
      color: var(--color-text-secondary);
      display: inline-flex;
      flex: 0 0 auto;
      font-size: var(--font-size-caption);
      font-variant-numeric: tabular-nums;
      font-weight: 800;
      gap: var(--space-2);
    }
    .set-chips {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-2);
    }
    .set-chip {
      align-items: center;
      background: var(--color-surface);
      border: 1px solid var(--color-border-subtle);
      border-radius: var(--radius-md);
      color: var(--color-text-secondary);
      display: inline-flex;
      flex-direction: column;
      gap: 0.1rem;
      line-height: 1.05;
      min-width: 3.4rem;
      padding: 0.35rem 0.7rem;
    }
    .set-chip__num {
      font-size: var(--font-size-caption);
      font-weight: 900;
    }
    .set-chip__score {
      font-size: var(--font-size-caption);
      font-variant-numeric: tabular-nums;
      font-weight: 700;
      opacity: 0.85;
    }
    .set-chip.done {
      background: color-mix(in srgb, var(--color-primary) 8%, var(--color-surface));
      border-color: color-mix(in srgb, var(--color-primary) 32%, var(--color-border-subtle));
      color: var(--color-primary-strong);
    }
    .set-chip.active {
      background: var(--color-primary);
      border-color: var(--color-primary);
      color: var(--color-on-strong);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingLiveBoardComponent {
  readonly preview = LANDING_SCORING_PREVIEW;
  readonly noControls = [] as const;
}
